export const messages = {
  en: {
    inoutOrder: {
      queryConditions: 'Query Conditions',
      inoutOrderInfo: 'Inbound Order Information',
      orderId: 'Order ID',
      product: 'Product',
      applicant: 'Applicant',
      createTime: 'Create Time',
      remark: 'Remark',
      status: 'Status',
      operation: 'Operation',
      inputApplicant: 'Please input applicant name',
      inputOrderId: 'Please input order ID',
      selectStatus: 'Please select status',
      query: 'Query',
      reset: 'Reset',
      inbound: 'Inbound',
      detail: 'Detail'
    }
  },
  zh: {
    inoutOrder: {
      queryConditions: '查询条件',
      inoutOrderInfo: '入库单信息',
      orderId: '订单ID',
      product: '商品',
      applicant: '申请人',
      createTime: '创建时间',
      remark: '备注',
      status: '状态',
      operation: '操作',
      inputApplicant: '请输入申请人名称',
      inputOrderId: '请输入单号',
      selectStatus: '请选择状态',
      query: '查询',
      reset: '重置',
      inbound: '入库',
      detail: '详情'
    }
  }
}